import './App.css';
import Head from "./components/Head";
import MainContainer from "./components/MainContainer";
import Foot from "./components/Foot";
import { LoginContextProvider } from "./components/LoginContext";

function App() {
  return (
    <div className="">
      <LoginContextProvider>
        <Head />
        <MainContainer />
        <Foot />
      </LoginContextProvider>
    </div>
  );
}

export default App;
